import * as React from 'react';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { compose, withHandlers, withProps } from 'recompose';
import { reduxForm } from 'redux-form';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { Card } from 'material-ui';
import { cancelTickets } from '@modules/tickets/_ticketsActions';
import { TicketsCancelFormBasic } from '@modules/tickets/TicketsCancelFormBasic';

export const enhance = compose<any, any>(
  withHandlers({
    onSubmit: ({ closeItem, refresh, handleLoader }) => async data => {
      handleLoader(true);
      const result = await cancelTickets(data);
      if (result) {
        if (refresh) {
          refresh();
        }
        await closeItem();
      }
      handleLoader(false);
    }
  }),
  withProps(({ checkedItems }) => ({
    initialValues: {
      checkedItems
    }
  })),
  breadcrumbs(() => [{ label: 'Storno' }]),
  reduxForm({ form: 'tickets-cancel' })
);

const View: React.SFC<any> = ({ handleSubmit, closeItem }) => (
  <div>
    <form className="layout" onSubmit={handleSubmit}>
      <Card>
        <TicketsCancelFormBasic />
        <Button type="submit" label="Stornovat" primary={true} style={{ margin: '16px 0 16px 16px' }} />
        <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
      </Card>
    </form>
  </div>
);
export const TicketsCancelForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/tickets/TicketsCancelForm.tsx